import { Box, Grid, Typography } from "@mui/material";

const features = [
  {
    title: "Contact Review & Comparison",
    description: `Spot differences, missing clauses, or risk terms across multiple agreements - side-by-side and in seconds.`,
  },
  {
    title: "Compliance & Risk Analysis",
    description: `Uncover obligations, deadlines, and exceptions buried deep in documentation - with full traceability.`,
  },
  {
    title: "Document Summarization & Reporting",
    description: `Turn hundreds of pages into clear, actionable summaries - no more manual notes.`,
  },
  {
    title: "Knowledge Management",
    description: `Make internal documents accessible via natural language search - no tagging, no formatting.`,
  },
  {
    title: "Customer Support & Operations",
    description: `Help frontline teams quickly respond to customer questions using live answers pulled from official documentation.`,
  },
  {
    title: "Internal Audit & QA",
    description: `Verify whether procedures were followed or standards met — directly from internal manuals, reports, or SOPs.`,
  },
];

export default function SmartCapabilities({ lessThanXL }) {
  return (
    <Box
      mt={12}
      sx={{
        color: "#1F1F1F",
        paddingLeft: !lessThanXL ? "70px" : "21px",
        paddingRight: !lessThanXL ? "70px" : "21px",
      }}
    >
      <Typography
        fontWeight="700"
        component="span"
        sx={{
          marginRight: "10px",
          fontSize: !lessThanXL ? "34px" : "32px",
          fontStyle: !lessThanXL ? "italic" : "",
          background: (theme) => theme.palette.gradient.toTop,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: "normal",
        }}
      >
        Smart Capabilities
      </Typography>
      <Typography
        sx={{
          fontSize: !lessThanXL ? "34px" : "32px",
        }}
        component={"span"}
        fontWeight="700"
        lineHeight={"normal"}
        gutterBottom
      >
        for Every Department
      </Typography>
      <Typography
        mt={5}
        lineHeight={"normal"}
        variant="body1"
        fontSize="18px"
        fontWeight={400}
        mb={6}
      >
        Dokusense enhances workflows across legal, compliance, operations, and
        beyond.
        <br />
        Wherever teams work with complex documents, we make content usable,
        searchable, and explainable.
      </Typography>
      <Grid container>
        {features.map((feature, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{
              marginTop: "15px",
            }}
          >
            <Box
              sx={{
                height: "150px`",
                maxWidth: "350px",
                background: "transparent",
                color: "#1F1F1F",
                paddingTop: "30px",
                paddingBottom: "30px",
              }}
            >
              <Typography
                lineHeight={"normal"}
                variant="subtitle1"
                sx={{
                  background: (theme) => theme.palette.gradient.toTop,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
                fontWeight="700"
                fontSize="24px"
                gutterBottom
              >
                {feature.title}
              </Typography>
              <Typography
                lineHeight={"normal"}
                variant="body2"
                fontSize="18px"
                fontWeight={400}
              >
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
